module.exports = __webpack_public_path__ + "public/images/reviews/review-alexandr.0660f0287ae7ecc20f7c8db68aa71c0d.png";